// extracted by mini-css-extract-plugin
export var menuIcon = "_rx-0";
export var menuIconInline = "_rx-1";